<div class="app-alert">
  <strong>{{ label | translate}}!</strong>
  <span>
    {{ message | translate}}
  </span>
</div>